import type { HttpClient } from '@/lib/http/client.js'
import type { ReconcileInput, RollupHealth } from '@/types/analytics/analytics.type.js'

/** `admin/analytics`, verified against `analytics-admin.controller.ts`. Both need `analytics-view`. */
export interface AnalyticsService {
  health: () => Promise<RollupHealth>
  /** Idempotent: rows are replaced with what the log says. The DTO is QUERY parameters. */
  reconcile: (input: ReconcileInput) => Promise<{ rows: number }>
}

export function createAnalyticsService(http: HttpClient): AnalyticsService {
  return {
    health: () => http.get<RollupHealth>('admin/analytics/health'),
    reconcile: (input) => http.post<{ rows: number }>('admin/analytics/reconcile', undefined, { query: { ...input } }),
  }
}
